export const thirdPartyEnums = {
  NORMAL: 'NORMAL',
  PARENT: 'PARENT',
  CHILD: 'CHILD',
};
